var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgStatusPending = function SvgStatusPending(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.124 13H11.876C11.599 11.972 10.892 11.375 10.154 10.752C9.349 10.071 8.436 9.3 8.427 8.007C8.436 6.701 9.349 5.93 10.153 5.249C10.892 4.625 11.598 4.028 11.876 3H4.124C4.401 4.028 5.108 4.625 5.847 5.249C6.651 5.93 7.563 6.701 7.573 7.992C7.563 9.3 6.651 10.071 5.846 10.751C5.108 11.375 4.401 11.972 4.124 13ZM13 15H3C2.447 15 2 14.553 2 14C2 11.383 3.477 10.135 4.555 9.224C5.185 8.691 5.57 8.348 5.573 7.992C5.57 7.653 5.185 7.309 4.556 6.777C3.477 5.865 2 4.617 2 2C2 1.447 2.447 1 3 1H13C13.553 1 14 1.447 14 2C14 4.617 12.523 5.865 11.444 6.776C10.815 7.309 10.429 7.652 10.427 8.007C10.429 8.348 10.815 8.691 11.445 9.224C12.523 10.136 14 11.384 14 14C14 14.553 13.553 15 13 15Z",
    fill: "#A1A3A7"
  })));
};
export default SvgStatusPending;